import { AnimatePresence } from "framer-motion";
import { Button } from "../../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Download, Loader2, File } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { previewMode } from "../../lib/filePreview";

export function FilePreviewModal({ previewFile, previewUrl, previewLoading, closePreview, handleDownload }) {
  // Taken from the context rather than a prop: the two buttons at the bottom
  // were the only English left in this dialog, and threading t through
  // ProjectDetail to reach them would have been a change to three files to fix
  // two words.
  const { t } = useLanguage();

  // The same table the page consulted before opening this dialog. It used to
  // decide for itself, and more loosely — anything starting with "text/" went
  // into an iframe, which included text/html.
  const mode = previewFile ? previewMode(previewFile.content_type) : null;

  return (
    <AnimatePresence>
      {previewFile && (
        <Dialog open={!!previewFile} onOpenChange={closePreview}>
          <DialogContent className="max-w-4xl max-h-[90vh] overflow-hidden">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2 min-w-0">
                <File className="w-5 h-5 shrink-0" />
                <span className="truncate">{previewFile.original_filename}</span>
              </DialogTitle>
            </DialogHeader>
            <div className="mt-4 overflow-auto max-h-[70vh]">
              {previewLoading ? (
                <div className="flex items-center justify-center py-20">
                  <Loader2 className="w-6 h-6 animate-spin text-indigo-600" />
                </div>
              ) : previewUrl ? (
                /* This branch must stay an <img>. An SVG shown in an image tag
                   cannot run its own script; the same file in a frame can. */
                mode === "image" ? (
                  <img src={previewUrl} alt={previewFile.original_filename} className="max-w-full mx-auto" />
                ) : mode === "pdf" ? (
                  <iframe src={previewUrl} className="w-full h-[65vh]" title={previewFile.original_filename} />
                ) : mode === "text" ? (
                  <iframe src={previewUrl} className="w-full h-[65vh] bg-slate-50" title={previewFile.original_filename} />
                ) : null
              ) : null}
            </div>
            <div className="flex flex-wrap justify-end gap-2 mt-4">
              <Button variant="outline" onClick={closePreview} className="border-slate-200">
                {t("common.close")}
              </Button>
              <Button onClick={() => handleDownload(previewFile)} className="bg-indigo-700 hover:bg-indigo-600">
                <Download className="w-4 h-4 mr-1" />
                {t("file.download")}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </AnimatePresence>
  );
}
